// import { useNavigate } from 'react-router-dom';
// import { runInBackground } from '@/lib/utils';
// import { Button } from '@/components/ui/button';
// import { createComponentLogger } from '@/lib/logging/frontend-logger';

interface BackButtonProps {
    href?: string;
    onClick?: () => void;
    tooltip: string;
    className?: string;
}

/*
 * The Back Button is sorely broken: it sends the user "back" to a random and surprising place in the portal. The only
 * way to implement this properly is to use breadcrumbs.
 */
export function BackButton(_: BackButtonProps) {
    return null;
}

// export function BackButton({ href, onClick, tooltip, className = '' }: BackButtonProps) {
//     const log = createComponentLogger('BackButton');
//     // Temporarily hidden to prevent covering Card Column elements
//     const navigate = useNavigate();

//     const handleClick = () => {
//         if (onClick) {
//             onClick();
//         }
//         if (href) {
//             runInBackground(navigate(href), (err) => {
//                 log.error('Error navigating', err);
//             });
//         } else if (!onClick) {
//             // Only use navigate(-1) if neither onClick nor href is provided
//             runInBackground(navigate(-1), (err) => {
//                 log.error('Error navigating back', err);
//             });
//         }
//     };

//     // Position: sidebar is 256px (w-64), content padding is 32px (p-8)
//     // Center between sidebar edge (256px) and content start (~288px) = ~272px
//     // Using 280px for better visual centering
//     return (
//         <Button
//             variant="ghost"
//             size="icon"
//             onClick={handleClick}
//             className={`fixed left-[280px] top-4 z-10 border border-gray-300 rounded-md bg-white hover:bg-gray-50 ${className}`}
//             title={tooltip}
//         >
//             ◀
//         </Button>
//     );
// }
